export default __webpack_public_path__ + "static/media/Banner_image_CSI_DH.9fd60a61.jpg";